<template>
  <section id="hero">
    <v-parallax height="850" dark class="parallax-container">
      <!-- Video de fondo -->
      <video
        autoplay
        muted
        loop
        playsinline
        class="video-background"
        ref="videoElement"
      >
        <source src="@/assets/Videos/tablet.mp4" type="video/mp4" />
      </video>

      <!-- Imagen de fondo (se muestra solo si el video no funciona) -->
      <div class="fallback-image"></div>
      <!-- Capa opaca -->
      <div class="overlay"></div>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="6" xl="8">
              <h2 class="titulo-principal">
                Digitaliza tus órdenes de servicio y toma el control total de tu
                taller
              </h2>
              <h3 class="subtitulo">
                Optimiza procesos, evita errores y gestiona cada trabajo con
                precisión
              </h3>
              <v-btn
                rounded
                outlined
                large
                dark
                :href="'https://wa.me/+5214434846542?text=Estoy%20interesado%20en%20el%20servicio.'"
                target="_blank"
                class="mt-5"
              >
                Obtén acceso ahora
                <v-icon class="ml-2">mdi-cart</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" xl="4" class="hidden-sm-and-down"> </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg" />
      </div>
    </v-parallax>
    <v-container fluid id="features" class="mt-2">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="space-around">
            <v-col cols="12" class="text-center">
              <h1
                class="font-weight-bold text-primary mb-4 text-xs-h4 text-md-h3 text-lg-h2"
              >
                Orden de Servicio Digital Automotriz (OSD)
              </h1>
            </v-col>

            <!-- Contenedor de características -->
            <v-row align="center">
              <!-- Columna del texto (Izquierda) -->
              <v-col cols="12" md="6">
                <p class="font-weight-light">
                  La falta de organización en las órdenes de servicio de
                  talleres genera errores, retrasos y malentendidos que afectan
                  la productividad y la experiencia del cliente. Un Sistema de
                  Orden de Servicio Digital (OSD) centraliza y automatiza
                  procesos, mejorando la precisión, la comunicación y la
                  eficiencia. Esto se traduce en menos errores, mayor
                  productividad y una experiencia más profesional y
                  satisfactoria para los clientes.
                </p>
                <p class="font-weight-light">
                  <strong
                    >Problemas comunes en la gestión de órdenes de
                    servicio:</strong
                  ><br /><br />
                  ✖ Los papeles pueden perderse, lo que genera
                  confusión y errores en los trabajos.<br />
                  ✖ La falta de un sistema organizado provoca retrasos y
                  dificulta el seguimiento de cada tarea.<br />
                  ✖ Sin un control adecuado, los clientes reciben información
                  imprecisa sobre el estado de su vehículo, afectando su
                  confianza.<br /><br />

                  <strong>¿Cómo te ayudamos?</strong><br /><br />
                  ✓ Con nuestro Sistema de Orden de Servicio Digital (OSD),
                  tienes control total sobre cada trabajo, evitando pérdidas de
                  datos y mejorando la eficiencia.<br />
                  ✓ Digitaliza tus órdenes y obtén una visión clara del estado
                  de cada servicio, desde la recepción hasta la entrega,
                  optimizando la gestión del taller.<br />
                  ✓ Mantén informados a tus clientes en todo momento con
                  actualizaciones precisas y rápidas, brindando un servicio más
                  profesional y confiable.<br />
                </p>
              </v-col>

              <!-- Columna de la imagen (Derecha) -->
              <v-col cols="12" md="6" class="text-center">
                <img
                  src="@/assets/img/tablet.png"
                  alt="Testimonios"
                  class="img-fluid"
                />
                <v-btn
                  rounded
                  style="background-color: #a2c334"
                  class="mt-2 white--text"
                  large
                  :href="'https://wa.me/+5214434846542?text=Estoy%20interesado%20en%20optimizar%20mi%20taller%20con%20OSD.'"
                  target="_blank"
                >
                  ¡Automatiza y crece tu taller!
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="dialog"
      max-width="75%"
      transition="dialog-bottom-transition"
    >
      <div
        style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          overflow: hidden;
          width: 100%;
        "
      >
        <iframe
          v-if="dialog"
          :src="`https://www.youtube.com/embed/${videoId}?autoplay=1`"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        ></iframe>
      </div>
    </v-dialog>

    <div class="svg-border-waves">
      <img src="~@/assets/img/wave2.svg" />
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      videoId: "C_HxcwDBqvY", // ID del video de YouTube
    };
  },
  mounted() {
    // Espera a que el video cargue
    const video = this.$refs.videoElement;
    if (video) {
      video.onerror = () => {
        // Si el video no carga, muestra la imagen de fondo
        document.querySelector(".fallback-image").style.display = "block";
        video.style.display = "none"; // Oculta el video
      };
    }
  },
};
</script>

<style lang="scss">
/* Video de fondo */
.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2; /* Asegura que esté detrás del contenido */
}

/* Imagen de fondo (se oculta si el video carga bien) */
.fallback-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("../assets/img/bgHero.jpg");
  background-size: cover;
  background-position: center;
  display: none; /* Se mostrará solo si el video falla */
}

.image-section {
  flex: 1;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.image {
  max-width: 100%;
  max-height: 500px;
  object-fit: cover;
}

.text-section {
  flex: 1;
  text-align: center;
}

ul {
  margin: 0;
  padding-left: 1.5rem;
}
p {
  color: white;
  font-size: 1.1rem;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex; /* Activa Flexbox */
  justify-content: center; /* Alinea horizontalmente */
  align-items: center; /* Alinea verticalmente */
  border-radius: 2%;
}

/* Capa opaca */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Negro semitransparente */
  z-index: -1; /* Entre el video y el contenido */
}

.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
.text-primary {
  color: #9abe23; /* Azul primario */
  font-size: 2rem;
}
p {
  font-size: 1.3rem;
  line-height: 1.6;
  color: #676767;
}

.circle {
  stroke: white;
  stroke-dasharray: 650;
  stroke-dashoffset: 650;
  -webkit-transition: all 0.5s ease-in-out;
  opacity: 0.3;
}

.playBut {
  /*  border: 1px solid red;*/
  display: inline-block;
  -webkit-transition: all 0.5s ease;

  .triangle {
    -webkit-transition: all 0.7s ease-in-out;
    stroke-dasharray: 240;
    stroke-dashoffset: 480;
    stroke: white;
    transform: translateY(0);
  }

  &:hover {
    .triangle {
      stroke-dashoffset: 0;
      opacity: 1;
      stroke: white;
      animation: nudge 0.7s ease-in-out;

      @keyframes nudge {
        0% {
          transform: translateX(0);
        }
        30% {
          transform: translateX(-5px);
        }
        50% {
          transform: translateX(5px);
        }
        70% {
          transform: translateX(-2px);
        }
        100% {
          transform: translateX(0);
        }
      }
    }

    .circle {
      stroke-dashoffset: 0;
      opacity: 1;
    }
  }
}
.btn-play {
  transition: 0.2s;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

#hero {
  z-index: 0;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
.text-primary {
  color: #9abe23; /* Azul primario */
  font-size: 2rem;
}
p {
  font-size: 1.3rem;
  line-height: 1.6;
  color: #676767;
}

@media (max-width: 600px) {
  p {
    font-size: 1.1rem;
    line-height: 1.4;
  }
  .play-icon {
    background: rgba(0, 0, 0, 0);
  }
}

section {
  position: relative;
}

.img-fluid {
  max-width: 100%; /* Hace que la imagen sea responsiva */
  height: auto;
}

/* Asegurar que la imagen esté centrada en pantallas pequeñas */
@media (max-width: 768px) {
  .text-center img {
    margin: 0 auto;
  }
}

.titulo-principal {
  font-size: 2.5rem;
  font-weight: 500;
  color: white;
  text-transform: uppercase;
}

.subtitulo {
  font-size: 2rem;
  color: white;
  font-weight: 300;
  text-transform: uppercase;
}

/* Para tablets */
@media (max-width: 768px) {
  .titulo-principal {
    font-size: 2.5rem;
  }
  .subtitulo {
    font-size: 2rem;
  }
}

/* Para móviles */
@media (max-width: 480px) {
  .titulo-principal {
    font-size: 2rem;
  }
  .subtitulo {
    font-size: 1.5rem;
  }
}

@media (max-width: 768px) {
  .video-background {
    object-position: 65% center;
  }
}
</style>
